if (!customElements.get("cart-recommendations-carousel")) {
	customElements.define(
		"cart-recommendations-carousel",
		class CartRecommendationsCarousel extends HTMLElement {
			constructor() {
				super();

				this.itemsContainer = this.querySelector(".cart-recommendations__items");
				this.prevButton = this.querySelector(".cart-recommendations__nav--prev");
				this.nextButton = this.querySelector(".cart-recommendations__nav--next");
				this.items = this.querySelectorAll(".cart-recommendations__item");
				this.forms = this.querySelectorAll(".cart-recommendations__form");

				this.currentIndex = 0;
				this.itemWidth = 0;
				this.recommendationsUrl = this.dataset.url;
				this.fallbackCollection = this.dataset.fallbackCollection;

				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");

				this.loadRecommendations();
			}

			async loadRecommendations() {
				try {
					// Obtener el carrito
					const cartResponse = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`);
					const cart = await cartResponse.json();

					if (!cart.items || cart.items.length === 0) {
						this.init();
						return;
					}

					// Obtener el primer producto del carrito
					const firstProductId = cart.items[0].product_id;

					// Cargar recomendaciones desde la API de Shopify
					if (this.recommendationsUrl && firstProductId) {
						const recommendationsUrl = `${this.recommendationsUrl}&product_id=${firstProductId}&section_id=cart-recommendations`;
						
						const response = await fetch(recommendationsUrl);
						const text = await response.text();
						
						const html = document.createElement("div");
						html.innerHTML = text;
						
						// Buscar items de recomendación en la respuesta (formato de nuestra sección)
						const recommendationItems = html.querySelectorAll(".cart-recommendations__item[data-product-id]");
						
						if (recommendationItems && recommendationItems.length > 0) {
							// Limpiar items de fallback
							const fallbackItems = this.itemsContainer.querySelectorAll("[data-fallback-item]");
							fallbackItems.forEach(item => item.remove());
							
							// Agregar los items de recomendación directamente
							recommendationItems.forEach((item, index) => {
								if (index >= 5) return; // Limitar a 5 productos
								
								// Clonar el item y agregarlo al contenedor
								const clonedItem = item.cloneNode(true);
								this.itemsContainer.appendChild(clonedItem);
							});
						} else {
							// Si no hay items en nuestro formato, intentar parsear de related-products
							this.parseRecommendationsFromHTML(html);
						}
					}
				} catch (error) {
					console.error("Error loading cart recommendations:", error);
				}
				
				// Inicializar el carousel con los items disponibles (recomendaciones o fallback)
				this.init();
			}

			parseRecommendationsFromHTML(html) {
				// Intentar encontrar productos en formato related-products (grid__item)
				const gridItems = html.querySelectorAll(".grid__item");
				
				if (gridItems.length > 0) {
					gridItems.forEach((item, index) => {
						if (index >= 5) return;
						
						const productLink = item.querySelector("a[href*='/products/']");
						if (!productLink) return;
						
						const productUrl = productLink.getAttribute("href");
						const productCard = item.querySelector(".card-product, .product-card");
						
						if (productCard) {
							const image = productCard.querySelector("img");
							const title = productCard.querySelector("h3, .card__heading, .product-card__title") || productLink;
							const price = productCard.querySelector(".price, .product-card__price");
							
							// Obtener variant ID del formulario de quick add o del link
							let variantId = productCard.querySelector('input[name="id"]')?.value;
							
							// Si no hay variant ID, necesitamos obtenerlo del producto
							if (!variantId && productUrl) {
								// Extraer handle del producto de la URL
								const productHandle = productUrl.match(/\/products\/([^?#]+)/)?.[1];
								if (productHandle) {
									// Intentar obtener el variant ID haciendo fetch al producto
									this.fetchProductVariant(productHandle, {
										url: productUrl,
										image: image?.getAttribute("src") || image?.getAttribute("data-src"),
										title: title?.textContent?.trim() || title?.getAttribute("title") || "Product",
										price: price?.textContent?.trim() || ""
									});
									return;
								}
							}
							
							if (variantId) {
								this.createRecommendationItem({
									url: productUrl,
									image: image?.getAttribute("src") || image?.getAttribute("data-src"),
									title: title?.textContent?.trim() || title?.getAttribute("title") || "Product",
									price: price?.textContent?.trim() || "",
									variantId: variantId
								});
							}
						}
					});
				}
			}

			async fetchProductVariant(productHandle, productData) {
				try {
					const productUrl = `/products/${productHandle}.js`;
					const response = await fetch(productUrl);
					const product = await response.json();
					
					if (product && product.variants && product.variants.length > 0) {
						const firstAvailableVariant = product.variants.find(v => v.available) || product.variants[0];
						this.createRecommendationItem({
							...productData,
							variantId: firstAvailableVariant.id.toString()
						});
					}
				} catch (error) {
					console.error("Error fetching product variant:", error);
				}
			}

			createRecommendationItem({ url, image, title, price, variantId }) {
				if (!variantId) return;
				
				const item = document.createElement("div");
				item.className = "cart-recommendations__item";
				
				const imageHtml = image 
					? `<img src="${image}" alt="${title}" loading="lazy" width="40" height="40">`
					: '<svg class="placeholder-svg" viewBox="0 0 100 100"><rect width="100" height="100" fill="#f0f0f0"/></svg>';
				
				item.innerHTML = `
					<a href="${url}" class="cart-recommendations__item-image">
						${imageHtml}
					</a>
					<div class="cart-recommendations__item-info">
						<h3 class="cart-recommendations__item-title">
							<a href="${url}">${title}</a>
						</h3>
					</div>
					<div class="cart-recommendations__item-actions">
						<form
							method="post"
							action="${window.routes?.cart_add_url || "/cart/add"}"
							accept-charset="UTF-8"
							class="cart-recommendations__form"
							enctype="multipart/form-data"
							data-type="add-to-cart-form"
						>
							<input type="hidden" name="form_type" value="product">
							<input type="hidden" name="utf8" value="✓">
							<input type="hidden" name="id" value="${variantId}">
							<input type="hidden" name="quantity" value="1">
							<button
								type="submit"
								name="add"
								class="cart-recommendations__add-button"
							>
								Add 1 ${price || ""}
							</button>
						</form>
					</div>
				`;
				
				this.itemsContainer.appendChild(item);
			}

			init() {
				// Actualizar referencias a items después de cargar recomendaciones
				this.items = this.querySelectorAll(".cart-recommendations__item");
				this.forms = this.querySelectorAll(".cart-recommendations__form");
				
				if (this.items.length === 0) return;

				this.setupCarousel();
				this.setupNavigation();
				this.setupAddToCart();
				this.updateNavigation();
			}

			setupCarousel() {
				if (!this.itemsContainer || this.items.length === 0) return;

				const containerWidth = this.itemsContainer.parentElement.offsetWidth;
				const navButtonsWidth = 90; 
				const marginRight = 15;
				this.itemWidth = containerWidth - navButtonsWidth + marginRight;
				this.maxIndex = Math.max(0, this.items.length - 1);

				if (this.currentIndex > this.maxIndex) {
					this.currentIndex = this.maxIndex;
				}

				this.updateCarouselPosition();
				this.updateNavigation();
			}

			setupNavigation() {
				if (!this.prevButton || !this.nextButton) return;

				this.prevButton.addEventListener("click", () => {
					if (this.currentIndex > 0) {
						this.currentIndex--;
						this.updateCarouselPosition();
						this.updateNavigation();
					}
				});

				this.nextButton.addEventListener("click", () => {
					if (this.currentIndex < this.maxIndex) {
						this.currentIndex++;
						this.updateCarouselPosition();
						this.updateNavigation();
					}
				});
			}

			setupAddToCart() {
				if (!this.forms.length) return;

				this.forms.forEach((form) => {
					form.addEventListener("submit", this.handleAddToCart.bind(this));
				});
			}

			handleAddToCart(evt) {
				evt.preventDefault();

				const form = evt.currentTarget;
				const submitButton = form.querySelector(
					".cart-recommendations__add-button",
				);
				const originalText = submitButton.textContent;

				if (submitButton.hasAttribute("disabled")) return;

				submitButton.setAttribute("disabled", "disabled");
				submitButton.classList.add("is-adding");
				submitButton.textContent = "Adding...";

				const config = this.getFetchConfig();
				const formData = new FormData(form);

				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id),
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}

				config.body = formData;

				fetch(`${window.routes?.cart_add_url || "/cart/add"}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							this.handleAddToCartError(response, submitButton, originalText);
						} else if (!this.cart) {
							window.location = window.routes?.cart_url || "/cart";
							return;
						} else {
							this.handleAddToCartSuccess(response, submitButton, originalText);
						}
					})
					.catch((error) => {
						console.error("Add to cart error:", error);
						this.resetButton(submitButton, originalText);
					});
			}

			handleAddToCartError(response, button, originalText) {
				console.error("Add to cart error:", response);
				this.resetButton(button, originalText);
			}

			handleAddToCartSuccess(response, button, originalText) {
				button.classList.remove("is-adding");
				button.classList.add("is-added");
				button.textContent = "Added!";

				if (this.cart && !response.status) {
					if (typeof window.publish === "function" && window.PUB_SUB_EVENTS) {
						window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
							source: "cart-recommendations",
							productVariantId:
								response.items?.[response.items.length - 1]?.variant_id,
							cartData: response,
						});
					}
					this.cart.renderContents(response);
				}

				setTimeout(() => {
					this.resetButton(button, originalText);
				}, 2000);
			}

			resetButton(button, originalText) {
				button.removeAttribute("disabled");
				button.classList.remove("is-adding", "is-added");
				button.textContent = originalText;
			}

			updateCarouselPosition() {
				if (!this.itemsContainer || !this.itemWidth) return;

				const scrollLeft = this.currentIndex * this.itemWidth;
				this.itemsContainer.scrollTo({
					left: scrollLeft,
					behavior: "smooth",
				});
			}

			updateNavigation() {
				if (!this.prevButton || !this.nextButton) return;

				if (this.currentIndex <= 0) {
					this.prevButton.setAttribute("aria-disabled", "true");
					this.prevButton.style.opacity = "0.4";
				} else {
					this.prevButton.removeAttribute("aria-disabled");
					this.prevButton.style.opacity = "";
				}

				if (this.currentIndex >= this.maxIndex) {
					this.nextButton.setAttribute("aria-disabled", "true");
					this.nextButton.style.opacity = "0.4";
				} else {
					this.nextButton.removeAttribute("aria-disabled");
					this.nextButton.style.opacity = "";
				}
			}

			getFetchConfig() {
				const config = {
					method: "POST",
					headers: {
						"X-Requested-With": "XMLHttpRequest",
						Accept: "application/javascript",
					},
				};

				if (typeof window.fetchConfig === "function") {
					const themeConfig = window.fetchConfig("javascript");
					return { ...themeConfig, ...config };
				}

				return config;
			}
		},
	);
}
